// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H5iA","delete":"styles_delete__JzO4G","update":"styles_update__3H-5c","add":"styles_add__2yisI"};